import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UserProfile } from '../../_models/user-profile';
import { UserProfileService } from '../../_services/user-profile.service';
import { ConfigurationService } from '../../_services/configuration.service';

@Component({
  selector: 'app-top-navbar',
  templateUrl: './top-navbar.component.html',
  styleUrls: ['./top-navbar.component.css']
})
export class TopNavbarComponent implements OnInit, OnDestroy {
  userProfile: UserProfile;
  companylogo: string = '';
  companyDisplayName: string = '';
  lowerCaseCompName: string = '';
  portalVersion: string = '';
  customerLogosAvailable: Array<Object> = [];
  // Subjects
  private onDestroy$ = new Subject<void>();

  constructor(private userService: UserProfileService, private router: Router, private configurationService: ConfigurationService,) {
    this.userService.userProfile$.pipe(takeUntil(this.onDestroy$)).subscribe(
      userProfile => {
        this.userProfile = userProfile;
        this.displayCompanyLogo();
      });
    this.configurationService.configData$.pipe(takeUntil(this.onDestroy$)).subscribe(
      
      configData => {
        this.customerLogosAvailable = configData.companyLogos
        this.portalVersion = configData.version
      }
    );
  }

  ngOnInit(): void {
    this.displayCompanyLogo();
  }

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  openUserPage() {
    localStorage.setItem("mode", "editMode");
    this.router.navigate(['/app/ControlPanel/users/user/' + this.userProfile.name]);
  }

  private displayCompanyLogo() {
    if (this.userProfile.currentCompany) {
      this.companyDisplayName = this.userProfile.currentCompany;
      this.lowerCaseCompName = this.userProfile.currentCompany.toLowerCase();

      let customerLogoObject = this.customerLogosAvailable.find(obj => obj["name"] === this.lowerCaseCompName);

      if (customerLogoObject) {
        this.companyDisplayName = customerLogoObject["displayName"]
        if (customerLogoObject["hasLogo"]) {
          this.companylogo = '/assets/customerlogos/' + this.lowerCaseCompName + '.png';
        }
        else {
          this.companylogo = '/assets/customerlogos/genericlogo.png';
        }
      }
      else {
        this.companyDisplayName = this.userProfile.currentCompany;
        /* Company not present in current list */
        this.companylogo = '/assets/customerlogos/genericlogo.png';
      }
    }
  }
}
